import { createActions } from 'redux-actions';
import types from './types';

// eslint-disable-next-line import/prefer-default-export
export const {
  setRequestError,
} = createActions(
  types.SET_REQUEST_ERROR,
);
